<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Advisor Identified At-Risk Students"
    [pathBreadcrumbs]="toolListService.getHelpPagePathBreadcrumbs('at_risk')"
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Advisor Identified
      At-Risk Tool. The Advisor Identified At-Risk Tool displays at-risk
      students identified by advisors.
    </div>

    <!-------------------- AT-RISK HELP GUIDE -------------------->
    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Success Metrics Section
          <i class="fa-solid fa-arrow-right"></i> Advisor Identified At-Risk
        </h1>

        <!---------- Advisor Identified At-Risk At First Glance ---------->

        <h3 class="h3-second-header">
          Advisor Identified At-Risk Tool At First Glance
        </h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 17.
          </li>
        </ol>

        <div>
          <br />
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageAtRiskFig17']"
            alt=""
          />
          <p class="picture-caption">
            Figure 17: Advisor Identified At-Risk Tool Page
          </p>
        </div>

        <br />
        <mat-divider></mat-divider>
        <br />

        <!---------- Advisor Identified At-Risk Student Result Table ---------->
        <h3 class="h3-second-header">
          Advisor Identified At-Risk Student Table
        </h3>

        <ul class="ordered-list">
          <li>
            The At-Risk Student Table can be filtered by College, Department,
            and Program to view specific students.
          </li>
          <li>
            You will also be able to reset the filters (green button) and
            download the table results (blue button) using the buttons next to
            the filters.
          </li>
          <div>
            <br />
            <img
              class="set-img-width-lg"
              [(src)]="env['logo_paths']['helpPageAtRiskFig17a']"
              alt=""
            />
            <p class="picture-caption">
              Figure 17a: At-Risk Table filters and buttons
            </p>
          </div>

          <li>
            In the At-Risk Student Table there are two buttons on the last
            column (Actions) to your right.
          </li>
          <ul>
            <li>A delete button to remove student from being at-risk.</li>
            <li>A expand (arrow down) button to view more information.</li>
          </ul>
          <div>
            <br />
            <img
              class="set-img-width-lg"
              [(src)]="env['logo_paths']['helpPageAtRiskFig17b']"
              alt=""
            />
            <p class="picture-caption">Figure 17b: At-Risk Table filter</p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Advisor Identified At-Risk Students',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
